DeepModel = require 'models/base/deep_model'
Collection = require 'models/base/collection'

module.exports = class AppointmentCollection extends Collection
  url: '/api/pronto/appointments/distinct'
  model: DeepModel